import { PipeTransform } from '@angular/core';
var FilterPipe3 = /** @class */ (function () {
    function FilterPipe3() {
    }
    FilterPipe3.prototype.transform = function (value, args) {
        if (!value)
            return null;
        if (!args)
            return value;
        args = args.toLowerCase();
        return value.filter(function (item) {
            return JSON.stringify(item).toLowerCase().includes(args);
        });
    };
    return FilterPipe3;
}());
export { FilterPipe3 };
